import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'semantic-ui-react';
import { withPopup } from '../../lib/popup';
import { Input, Popup } from '../../lib/custom-ui';

import { useForm } from '../../hooks';

import styles from './AddPopup.module.scss';

const AddStep = React.memo(({ onCreate, onSearchCustomers, onClose }) => {
  const [t] = useTranslation();

  const [data, handleFieldChange] = useForm({
    name: '',
    facebook: '',
    phone: '',
  });

  const nameField = useRef(null);
  const facebookField = useRef(null);
  // const phoneField = useRef(null);

  const handleSubmit = useCallback(() => {
    const cleanData = {
      ...data,
      name: data.name.trim(),
      facebook: data.facebook.trim(),
      phone: data.phone.trim(),
    };

    if (!cleanData.name) {
      nameField.current.select();
      return;
    }

    if (!cleanData.facebook) {
      facebookField.current.select();
      return;
    }

    if (!cleanData.phone) {
      // phoneField.current.select();
      // return;
      cleanData.phone = undefined;
    }

    onSearchCustomers(cleanData.name);
    onCreate(cleanData);
    onClose();
  }, [data, onSearchCustomers, onCreate, onClose]);

  useEffect(() => {
    nameField.current.select();
  }, []);

  return (
    <>
      <Popup.Header>
        {t('common.createCustomer', {
          context: 'title',
        })}
      </Popup.Header>
      <Popup.Content>
        <Form onSubmit={handleSubmit}>
          <Input
            fluid
            ref={nameField}
            name="name"
            value={data.name}
            className={styles.field}
            placeholder={`${t('common.name')} *`}
            onChange={handleFieldChange}
          />
          <Input
            fluid
            ref={facebookField}
            name="facebook"
            value={data.facebook}
            className={styles.field}
            placeholder={`${t('common.facebook')} *`}
            onChange={handleFieldChange}
          />
          <Input
            fluid
            name="phone"
            value={data.phone}
            className={styles.field}
            placeholder={t('common.phone')}
            onChange={handleFieldChange}
          />
          <Button positive content={t('action.createCustomer')} />
        </Form>
      </Popup.Content>
    </>
  );
});

AddStep.propTypes = {
  onCreate: PropTypes.func.isRequired,
  onSearchCustomers: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withPopup(AddStep);
